import React from 'react';

export const RACK_COLORS = ['blue', 'red', 'white', 'black', 'grey', 'pink', 'cream', 'ink', 'gold', 'forest'];

export const COLOR_LABEL = {
  blue: 'Navy',
  red: 'Crimson',
  white: 'White',
  black: 'Black',
  grey: 'Grey',
  pink: 'Pink',
  cream: 'Cream',
  ink: 'Ink',
  gold: 'Gold',
  forest: 'Forest',
};

export function Slot({ filled }) {
  return <div className={`slot${filled ? ' filled' : ''}`} />;
}

export function RackRow({ color, onClick, selected }) {
  const allFilled = color !== 'white';
  return (
    <div
      className={`rack-row ${color}${onClick ? ' clickable' : ''}${selected ? ' selected' : ''}`}
      onClick={onClick}
    >
      {[...Array(5)].map((_, i) => <Slot key={i} filled={allFilled} />)}
    </div>
  );
}

export default function Rack({ rows, compact, onRowClick, selectedRow }) {
  return (
    <div className={`rack${compact ? ' compact' : ''}`}>
      {rows.map((r, i) => (
        <RackRow
          key={i}
          color={r.color}
          onClick={onRowClick ? () => onRowClick(i) : undefined}
          selected={selectedRow === i}
        />
      ))}
    </div>
  );
}

export function rowsToVariant(rows) {
  return rows.map(r => COLOR_LABEL[r.color] || r.color).join(' / ');
}
